import { render, staticRenderFns } from "./FormInscription.vue?vue&type=template&id=2c022668&scoped=true"
import script from "./FormInscription.vue?vue&type=script&lang=ts"
export * from "./FormInscription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c022668",
  null
  
)

export default component.exports